export default __webpack_public_path__ + "static/media/redundantRequest.47942416.svg";